import {
  DGSegregationRuleApi,
  DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest,
  DGSegregationRuleDto,
  DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest,
} from '@storage/app/api'

export class DGSegregationRuleService {
  constructor(private api: DGSegregationRuleApi) {}

  async getAll(): Promise<Array<DGSegregationRuleDto>> {
    const { data: dbSegregationRules } = await this.api.dGSegregationRuleGetAll()
    return dbSegregationRules
  }

  async upsertBulk(
    request: DGSegregationRuleApiDGSegregationRuleUpsertBulkRequest,
  ): Promise<Array<DGSegregationRuleDto>> {
    const { data: dbSegregationRules } = await this.api.dGSegregationRuleUpsertBulk(request)
    return dbSegregationRules
  }

  async deleteBulk(
    request: DGSegregationRuleApiDGSegregationRuleDeleteBulkRequest,
  ): Promise<void> {
    await this.api.dGSegregationRuleDeleteBulk(request)
  }
}
